// 📁 popupStationOverlay.js
export default function showPopupStationOverlay() {
    // Vorhandenes Overlay entfernen
    const existing = document.getElementById('popup-station-overlay')
    if (existing) existing.remove()

    // Overlay
    const overlay = document.createElement('div')
    overlay.id = 'popup-station-overlay'
    overlay.style.position = 'fixed'
    overlay.style.top = 0
    overlay.style.left = 0
    overlay.style.width = '100vw'
    overlay.style.height = '100vh'
    overlay.style.display = 'flex'
    overlay.style.justifyContent = 'center'
    overlay.style.alignItems = 'center'
    overlay.style.zIndex = 9999
    overlay.style.animation = 'fadeIn 0.3s ease-out'

    // Box
    const box = document.createElement('div')
    box.style.background = '#ffffff'
    box.style.padding = '30px'
    box.style.borderRadius = '16px'
    box.style.maxWidth = '700px'
    box.style.width = '80vw'
    box.style.textAlign = 'center'
    box.style.boxShadow = '0 0 20px rgba(0,0,0,0.3)'
    box.style.position = 'relative'
    box.style.animation = 'popIn 0.3s ease-out'

    // Bild
    const img = document.createElement('img')
    img.src = 'images/zeitplanung.png' // ⬅️ ersetze durch deinen Bildpfad
    img.alt = 'Beschreibung'
    img.style.width = '100%'
    img.style.borderRadius = '12px'
    img.style.marginBottom = '20px'
    box.appendChild(img)

    // Text
    const text = document.createElement('p');
    text.innerHTML = `
      <strong>Meilenstein- und Zeitplanung im Change-Management bei der Einführung von KI-Systemen</strong><br><br>
    
      Eine klare Meilenstein- und Zeitplanung ist bei jeder Veränderung im Unternehmen unverzichtbar. 
      Sie schafft Struktur, gibt Orientierung und ermöglicht es, Fortschritte sichtbar zu machen. 
      Das gilt auch und gerade für die Einführung von KI-Systemen.<br><br>
    
      Besonders wichtig ist hierbei, dass KI-Projekte in der Regel nicht „auf Knopfdruck“ funktionieren. 
      Sie verlangen Pilotphasen, in denen die Systeme getestet werden, sowie iterative Anpassungen, 
      um sicherzustellen, dass die Lösung den Arbeitsalltag der Mitarbeitenden tatsächlich unterstützt.<br><br>
    
      Unternehmen sollten außerdem auch einkalkulieren, dass KI-Einführungen meist mehr Zeit benötigen 
      als andere Digitalisierungsmaßnahmen. Der Umgang mit KI-Systemen ist in vielen Arbeitsbereichen 
      und für die meisten Menschen noch neu, was zu einer höheren Anpassungszeit führt. Diese braucht es, 
      um Vertrauen aufzubauen, praktische Kompetenzen zu entwickeln und Gewohnheiten anzupassen.<br><br>
    
      So entsteht ein realistischer Zeitrahmen, der den besonderen Anforderungen von KI-Projekten gerecht wird 
      und Mitarbeitende aktiv in den Veränderungsprozess einbindet.<br><br>
    
      Das Bild zeigt einen beispielhaften Zeitplan über alle Phasen hinweg, je nach Umfang können die Zeitabschnitte stark variieren, 
      Pilotprojekte helfen auch hier bei der Abschätzung.
    `;
    text.style.fontSize = '1.1rem';
    text.style.lineHeight = '1.6';
    text.style.marginTop = '20px';
    box.appendChild(text);

    // Close-Button
    const close = document.createElement('button')
    close.textContent = '✖'
    close.style.position = 'absolute'
    close.style.top = '12px'
    close.style.right = '16px'
    close.style.fontSize = '20px'
    close.style.background = '#f44336'
    close.style.color = '#ffffff'
    close.style.border = 'none'
    close.style.borderRadius = '50%'
    close.style.cursor = 'pointer'
    close.style.width = '32px'
    close.style.height = '32px'
    close.onclick = () => overlay.remove()
    box.appendChild(close)

    // Anhängen
    overlay.appendChild(box)
    document.body.appendChild(overlay)

    // CSS Keyframes hinzufügen (falls nicht vorhanden)
    const style = document.createElement('style')
    style.textContent = `
        @keyframes fadeIn {
            from { opacity: 0 }
            to { opacity: 1 }
        }
        @keyframes popIn {
            0% { transform: scale(0.9); opacity: 0 }
            100% { transform: scale(1); opacity: 1 }
        }
    `
    document.head.appendChild(style)
}
